import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";

@Injectable()
export class AuthGuard {

    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return new Promise<boolean>((resolve, reject) => {

            if (this.authService.authUser && this.authService.authUser.userRole) {

                let res = false;

                route.data['userRole'].forEach((role: any) => {
                    if (this.authService.authUser?.userRole === role) {
                        res = true;
                    }
                });

                resolve(res);
            } else {
                this.router.navigate(['/login']);
                resolve(false);
            }
        });
    }

}